import { PropertyBase } from './property-base.model';

export class DropdownProperties extends PropertyBase {
  public items: DropdownItemProperties[];
  constructor(data: any = {}) {
    super();
    this.items = data.items || null;
    this.title = data.title || 'Items';
    this.value = data.value || '';
  }
}

export class ValuePair {
  public value: string;
  constructor(value: any) {
    this.value = value;
  }
}

export class TextValue {
  public text: ValuePair;
  public value: ValuePair;
  constructor(text: any, value: any) {
    this.text = new ValuePair(text);
    this.value = new ValuePair(value);
  }
}

export class DropdownItemProperties {
  properties: TextValue;
  constructor(text: any, value: any) {
    this.properties = new TextValue(text, value);
  }
}
